export const isExternalLink = (url: string): boolean => {
  try {
    return (
      url.startsWith('//') || !new URL(url).hostname.includes('.which.co.uk')
    )
  } catch (error) {
    return false
  }
}
